import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import { isMobile } from 'react-device-detect';

// images
import hcpMobile2En from "../assets/image/tutorial/hcp/mobile/hcpTutorial2-en.png";
import hcpDesktop2En from "../assets/image/tutorial/hcp/desktop/hcpTutorial2-en.png";
import tutorialArrow from "../assets/image/tutorialArrow.png";

const HcpTutorial2 = () => {

    const navigate = useNavigate();

    const [openTutorial, setOpenTutorial] = useState(true);

    return (
        <div>
            {
                isMobile ? (
                    <img src={hcpMobile2En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                ) : (
                    <img src={hcpDesktop2En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                )
            }
            <Modal
                open={openTutorial}
                onClose={() => setOpenTutorial(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                hideBackdrop={true}
            >
                <Box className="tutorial-modal-1">
                    <p style={{ fontSize: "18px" }}>Or register a patient by entering their MRN, IC or phone number</p>
                    <img src={tutorialArrow} alt="arrow" style={{ float: "right" }} onClick={() => navigate('/hcp/hcpTutorial3')} />
                </Box>
            </Modal>
        </div>
    );
};

export default HcpTutorial2;
